(() => {
  function init(scope) {
    scope.querySelectorAll('[data-wek-purchase]').forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      const button = form.querySelector('[type="submit"]');
      const quantity = form.querySelector('[name="quantity"]');
      const status = form.querySelector('[data-cart-status]');
      let busy = false;
      const update = () => {
        const variant = form.querySelector('[name="id"]:checked');
        button.disabled = busy || !variant || variant.dataset.available !== 'true';
        button.textContent = busy ? form.dataset.adding : variant ? form.dataset.add : form.dataset.unavailable;
        if (variant?.dataset.stock !== undefined) quantity.max = variant.dataset.stock;
        else quantity.removeAttribute('max');
      };
      form.addEventListener('change', update);
      update();
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (busy || button.disabled || !form.reportValidity()) return;
        busy = true;
        status.textContent = '';
        update();
        try {
          const response = await fetch(form.action + '.js', {
            method: 'POST', headers: {Accept: 'application/json'}, body: new FormData(form)
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || form.dataset.error);
          status.textContent = form.dataset.added;
          form.querySelector('[data-cart-link]').hidden = false;
        } catch (error) {
          status.textContent = error.message || form.dataset.error;
        } finally {
          busy = false;
          update();
        }
      });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
